import React, { Component } from "react";
import moment from "moment";

import { NavLink } from "react-router-dom";

const Receive = ({ report }) => {
  return (
    <tr>
      <td>{report.vendor ? report.vendor : "-"}</td>
      <td>{report.invoice ? <NavLink to={`/invoice/${report.invoice}/`}>{report.invoice_number}</NavLink> : "-"}</td>
      <td>{moment(report.invoice_date).format("MM/DD/YYYY hh:mm A")}</td>
      <td>{report.item}</td>
      <td>{report.brand ? report.brand : "-"}</td>
      <td>{report.grade ? report.grade : "N/A"}</td>
      <td>{report.vendor_lot_number}</td>
      <td>{moment(report.packing_date).format("L")}</td>
      <td>{report.weight}</td>
      <td>{report.quantity}</td>
    </tr>
  );
};

export default class ReceivingList extends Component {
  render() {
    const { reports } = this.props;
    return (
      <tbody>
        {reports.map((report, index) => {
          return <Receive report={report} key={index} />;
        })}
      </tbody>
    );
  }
}
